import { Component } from '@angular/core';
import { environment } from 'src/app/environments/environment';

@Component({
  selector: 'app-branding',
  template: `
    <div class="branding">
      <a href="#" routerLink="/">
      <span class="mat-subtitle-1">{{appTitle}}</span>
      <!--
        <img
          src="#"
          class="align-middle m-2"
          width="174"
          alt="logo"
        />
        -->
      </a>
    </div>
  `,
  styles: [`
    .branding a {
      text-decoration: none;
    }

    .branding .title {
      font-weight: bold;
    }
  `]
})
export class BrandingComponent {
  appTitle = environment.appTitle;
  constructor() {}
}
